import { useQuery } from "@apollo/client";
import {
  Box,
  Center,
  SimpleGrid,
  SkeletonCircle,
  SkeletonText,
  Spinner,
  Tag,
} from "@chakra-ui/react";
import { useContext, useEffect, useState } from "react";
import { IProduct } from "../../services/graphql/Product";
import { PRODUCTS } from "../../services/graphql/query/Product";
import { ContextApp } from "../../shared/ContextApp";
import { CardProducts } from "../CardProduct/CardProduct";
import { ProductSkeletonLoading } from "../ProductSkeletonLoading/ProductSkeletonLoading";

export interface IHomeProps {}
export default function Home(props: IHomeProps) {
  const { user } = useContext(ContextApp);
  const [loading, setLoading] = useState<boolean>(true);
  const [dataProducts, setDataProducts] = useState<IProduct[]>([]);
  const { fetchMore } = useQuery(PRODUCTS, {
    variables: {
      filter: user
        ? {
            user_id: user.id,
          }
        : undefined,
    },
    onCompleted: (data) => {
      const { products } = data;
      setDataProducts(products);
      setLoading(false);
    },
    onError: (error) => {
      setLoading(false);
    },
  });

  return (
    <>
      {loading ? (
        <SimpleGrid minChildWidth="200px" spacing="40px">
          <ProductSkeletonLoading />
        </SimpleGrid>
      ) : dataProducts.length ? (
        <SimpleGrid minChildWidth="200px" spacing="40px">
          {dataProducts.map((product: IProduct) => (
            <CardProducts
              dataProduct={product}
              finallyFavorite={() => {
                setLoading(true);
                fetchMore({})
                  .then((dataProducts) => {
                    const { data } = dataProducts;
                    const { products } = data;
                    setDataProducts(products);
                    setLoading(false);
                  })
                  .catch(() => {
                    setLoading(false);
                  });
              }}
            />
          ))}
        </SimpleGrid>
      ) : (
        <Center>
          <Tag>NO SE ENCONTRARON PRODUCTOS &#128532;</Tag>
        </Center>
      )}
    </>
  );
}
